import React from 'react';  
import styled from 'styled-components';  
  
const ImageContainer = styled.div`  
  position: relative;  
  width: 100%;  
  margin: 20px auto; /* 上下のマージンは20px、左右は自動で中央寄せ */
  margin-top: 20px;  
  // background-color: rgba(0, 0, 0, 0.2);  
  border-radius: 10px;  
  overflow: hidden;  
  
  @media (min-width: 768px) {  
    width: 50%;  
    margin-bottom: 0;  
    height: 100%;  
  }  
`;  
  
const StyledImage = styled.img`  
  width: 100%;  
  border-radius: 10px;  
`;  

const H2txet = styled.h2`
  // color: #006331;
  font-size: 1rem; 
  font-weight: bold;
  text-align: center;
  // margin-top: -10px;
`;
  
const LatestHarvestImages = ({ images }) => {  
  return (  
    <ImageContainer>  
      <H2txet>
       最新収穫画像
      </H2txet>
      {images.map((image, index) => (  
        <div key={index}>  
          <StyledImage src={`data:image/jpeg;base64,${image.data}`} alt={`テレメトリーデータ画像番号 ${index + 1}`} />  
          <p>{image.name}</p>  
        </div>  
      ))}  
    </ImageContainer>  
  );  
};  
  
export default LatestHarvestImages;  
